import { getStore, getState } from '../../store';

import ACTIONS from './actions';

export const getKey = (programType, programId) => `${programType}${programId}`;

export const getExpandedWidth = key => {
    const COLLAPSED_WIDTH = 60;
    let dayHeaders = getState().calendarCollapse.calendarCollapseConfig[key];
    let collapsedDays = 0;
    dayHeaders.map(day => {
        day.status && collapsedDays++;
    });
    const totalCollapsedWidth = collapsedDays * COLLAPSED_WIDTH;
    return `calc((100% - ${totalCollapsedWidth}px) / ${7 - collapsedDays})`;
};

export const createCollapseStatus = (programType, programId) => {
    let key = getKey(programType, programId);
    getStore().dispatch({
        type: ACTIONS.CREATE,
        key
    });
};



// WEBPACK FOOTER //
// ./src/state/reducer/calendarCollapse/calendarCollapse.js